module.exports = __webpack_public_path__ + "img/circle-orange.41390a5c.svg";